import { Card, Spin } from 'antd'
import React, { useEffect, useState } from 'react'
import { getDetailedrecord2 } from '../../API/api';
import Answercard from './Answercard';
import { useSelector } from 'react-redux';


export default function AnswersList({questionId, usertype, isShowAddAnswer, reload}) {
 const userState = useSelector(state=>state.user);
 const expertState = useSelector(state=>state.expertRecord);
 const [resp, setResp] = useState([]);
 const [isLoading, setLoading] = useState(false);
 const fetchQuestionDetail=()=>{
   setResp([]);
   setLoading(true);
   getDetailedrecord2("", [atob(questionId)], false).then(res=>{
     if (res===undefined) return;
     if(res.data.success){
       // console.log(res.data.data);
       setLoading(false);
       res.data.data[atob(questionId)] !== undefined && res.data.data[atob(questionId)].filter(obj=>{
         if(obj.answerStatus === 'answered' && obj.expertUuid === userState.geoAttributes.userId){
           isShowAddAnswer(false)
         }
       })
       setResp(res.data.data[atob(questionId)] !== undefined ?res.data.data[atob(questionId)]:[]);
     }
   })
 }
 useEffect(()=>{
   fetchQuestionDetail();
 },[expertState.detailedRefresh])
 return (
   <div className='mt-3'>
       {resp.map((obj,index)=>{
         return(
           <Answercard key={index} isLoading={isLoading} answer={obj} reload={reload}/>
         )
       })}
   </div>
 )
}
